import { inject, injectable } from "tsyringe";
import { ScratchGame } from "src/containers/wellbeing/rewards/domain/models/scratch-game";
import { ScratchGameService } from "src/containers/wellbeing/rewards/services/scratch-game-service/scratch-game-service";
import { autoBind } from "src/shared/decorators/autobind";
import { PgaPolicy } from "src/shared/models";

@injectable()
export class WellbeingRewardsService {
    constructor(
        @inject("ScratchGameService") private gameService: ScratchGameService
    ) {}

    @autoBind
    public hasAccess(
        policies: Array<PgaPolicy>,
        gamesAvailable: Array<ScratchGame>
    ): boolean {
        return this.gameService.hasAccess(policies, gamesAvailable);
    }
}
